import React from "react"
import { useSelector } from "react-redux"
import pluralize from "pluralize"
import { useCustomName } from "hooks"
import { getFormQuestions } from "reduxSlices/formBuilderSlice"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { workflowActionShape } from "utils/propTypeShapes"
import { WorkflowActionAddDepartmentIcon } from "shared/icons"
import ActionHeading from "./ActionHeading"
import ActionDetails from "./ActionDetails"
import ActionLabelContainer from "./ActionLabelContainer"

const AddDepartmentActionLabel = ({ action }) => {
  const questions = useSelector(getFormQuestions)
  const { data } = action
  const { questionUUID, segments } = data
  const question = questions.find((q) => q.uuid === questionUUID)

  const segmentsFormatted = Object.keys(segments).sort().map((segment) => segment.toUpperCase())
  const segmentsLabel = pluralize("segments", segmentsFormatted.length)

  const { nameInSentence: departmentNameInSentence } = useCustomName(DEPARTMENT_KEY)

  return (
    <ActionLabelContainer>
      <ActionHeading
        iconComponent={WorkflowActionAddDepartmentIcon}
        text={`Add ${departmentNameInSentence} members in ${segmentsLabel} ${segmentsFormatted}:`}
      />
      <ActionDetails>
        <span>selected in <span className="workflow-label">{question.prompt}</span></span>
      </ActionDetails>
    </ActionLabelContainer>
  )
}

AddDepartmentActionLabel.propTypes = {
  action: workflowActionShape.isRequired,
}

export default AddDepartmentActionLabel
